import { render, staticRenderFns } from "./salesList.vue?vue&type=template&id=031efa3a&scoped=true&"
import script from "./salesList.vue?vue&type=script&lang=js&"
export * from "./salesList.vue?vue&type=script&lang=js&"
import style0 from "./salesList.vue?vue&type=style&index=0&id=031efa3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031efa3a",
  null
  
)

export default component.exports